import React, {useMemo, useState} from 'react';
import {Text, TableColumnConfig, Button, Icon} from '@gravity-ui/uikit';
import {DataTable} from '../../shared';
import {ConsentDocumentVersion} from '../../entities';
import {formatDateTimeToLocal} from '../../shared';
import {Plus, ArrowDownToLine} from '@gravity-ui/icons';
import {AddDocumentVersionModal} from '../../features';
import styles from './DocumentVersionsTable.module.scss';

interface DocumentVersionsTableProps {
  versions: ConsentDocumentVersion[];
  documentId: string;
  documentTitle: string;
  isLoading?: boolean;
  isArchived?: boolean;
}

export const DocumentVersionsTable: React.FC<DocumentVersionsTableProps> = ({
  versions,
  documentId,
  documentTitle,
  isLoading = false,
  isArchived = false,
}) => {
  const [isAddVersionModalOpen, setIsAddVersionModalOpen] = useState<boolean>(false);

  const handleDownloadVersion = (fileUrl: string, versionId: string) => {
    const link = window.document.createElement('a');
    link.href = fileUrl;
    link.download = `${documentTitle}_v${versionId}.pdf`;
    link.target = '_blank';
    window.document.body.appendChild(link);
    link.click();
    window.document.body.removeChild(link);
  };

  const reversedVersions = useMemo(() => {
    if (!versions) return [];
    return [...versions].reverse();
  }, [versions]);

  const versionsColumns: TableColumnConfig<ConsentDocumentVersion>[] = [
    {
      id: 'versionNumber',
      name: 'Номер версии',
      template: (item) => {
        return (
          <div className={styles.versionNumberWrapper}>
            <div className={styles.versionNumberIcon} onClick={() => handleDownloadVersion(item.fileUrl, item.id)}>
              <Icon data={ArrowDownToLine} />
            </div>
            <Text variant="body-1">Версия {item.id}</Text>
          </div>
        );
      },
    },
    {
      id: 'createdAt',
      name: 'Дата создания',
      template: (item) => formatDateTimeToLocal(item.createdAt),
    },
    {
      id: 'description',
      name: 'Описание',
      template: (item) => item.description || '—',
    },
  ];

  return (
    <>
      <div className={styles.container}>
        <div className={styles.header}>
          <Text variant="subheader-3" className={styles.title}>
            Версии
          </Text>
          {!isArchived && (
            <Button view="normal" size="m" onClick={() => setIsAddVersionModalOpen(true)}>
              <Icon data={Plus} />
              Добавить версию
            </Button>
          )}
        </div>

        <DataTable
          data={reversedVersions}
          columns={versionsColumns}
          onRowClick={(item) => {
            handleDownloadVersion(item.fileUrl, item.id);
          }}
          isLoading={isLoading}
          emptyStateTitle="Нет версий"
          emptyStateDescription="У этого документа пока нет версий."
        />
      </div>

      <AddDocumentVersionModal
        open={isAddVersionModalOpen}
        setOpen={setIsAddVersionModalOpen}
        documentId={documentId}
        onVersionAdded={() => {}}
      />
    </>
  );
};
